import options from './search.component';

export default {
    selector: 'dtSimpleSearch',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/simple/index.js